import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { TosGate } from './TosGate';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const validateSession = useAuthStore((s) => s.validateSession);
  const location = useLocation();

  // Validate session on mount (proactive refresh)
  useEffect(() => {
    if (isAuthenticated) {
      validateSession();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <TosGate>{children}</TosGate>;
}
